import * as React from 'react'
import * as ReactDOM from 'react-dom/client'

import { Provider } from 'react-redux'
import { pdfjs } from 'react-pdf'

import store from '@store/index'
import App from './App'
import './web.config'

pdfjs.GlobalWorkerOptions.workerSrc =
  '//cf.infotrack.com.au/order-display/pdf.js/2.16.105/pdf2.worker.min.js'

const rootElement = document.getElementById('root')

rootElement &&
  ReactDOM.createRoot(rootElement).render(
    <Provider store={store}>
      <App />
    </Provider>
  )
